import React from "react";

const Tag = (props) => {
  return <div class="tag">{props.name}</div>;
};

export default Tag;
